import { render, staticRenderFns } from "./GreCidadeComponent.vue?vue&type=template&id=b139e512"
import script from "./GreCidadeComponent.vue?vue&type=script&lang=js"
export * from "./GreCidadeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports